import React from "react";
import { Modal, Button as BootstrapButton } from "react-bootstrap";
import { useCommonReducer } from "../../redux/slice/commonSlice";

export type ReleaseNotePopupProps = {
  open: boolean;
  onSubmit?: () => void;
  version?: string;
};

const ReleaseNotePopup: React.FC<ReleaseNotePopupProps> = ({
  open,
  onSubmit,
  version,
}) => {
   const commonReducer = useCommonReducer();
  const releaseNoteRaw = commonReducer.applicationData?.applicationNote;

  let releaseNote;

  if (releaseNoteRaw !== null) {
    try {
      releaseNote =
        typeof releaseNoteRaw === "string"
          ? JSON.parse(releaseNoteRaw)
          : releaseNoteRaw;
    } catch (error) {
      console.error("Error parsing releaseNote:", error, releaseNoteRaw);
      releaseNote = null;
    }
  } else {
    releaseNote = null;
  }

  return (
    <Modal
      show={open}
      onHide={onSubmit}
      centered
      contentClassName="rounded-4 border border-secondary"
      dialogClassName="modal-dialog-slide-down"
    >
      <Modal.Body
      >
        <div>
          <h5
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              marginBottom: "8px",
              color: "#c8b509",
            }}
          >
            Illinois Court Services App has been updated 🎉
          </h5>
          <p style={{ fontSize: "14px",  marginBottom: "16px" }}>
            The SW system got updated. Please click the Reload
          </p>

          {releaseNote && (
            <h6
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginTop: "16px",
                color: "#6360bd",
              }}
            >
              Software Release {version} - {releaseNote?.features || ""} 🚀
            </h6>
          )}

          {releaseNote?.date && (
            <p style={{ fontSize: "14px", color: "#5590d8" }}>{releaseNote.date}</p>
          )}

          {releaseNote?.details && (
            <div style={{ marginTop: "16px" }}>
              <p
                style={{
                  fontSize: "14px",
                  marginBottom: "8px",
                  color: "#7a7a7a",
                }}
              >
                {releaseNote?.subtitle}
              </p>
              <ul style={{ paddingLeft: "24px", marginBottom: "0" }}>
                {releaseNote.details.map((item: any, index: number) => (
                  <li
                    key={index}
                    style={{
                      listStyle: "none",
                      position: "relative",
                      fontSize: "14px",
                      color: "#7a7a7a",
                      marginBottom: "8px",
                    }}
                  >
                    <span
                      style={{
                        color: "#34D399",
                        fontWeight: "bold",
                        position: "absolute",
                        left: "-1.5em",
                      }}
                    >
                      ✔
                    </span>
                    <span style={{ color: "#000", fontWeight: "bold" }}>
                      {item.heading}:
                    </span>{" "}
                    {item.description}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end mt-3">
          <BootstrapButton
            onClick={onSubmit}
            style={{
              padding: "12px 24px",
              fontSize: "16px",
              fontWeight: "bold",
              borderRadius: "8px",
              background: "linear-gradient(90deg, #16a34a, #22c55e)",
              border: "none",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.background =
                "linear-gradient(90deg, #15803d, #16a34a)")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.background =
                "linear-gradient(90deg, #16a34a, #22c55e)")
            }
          >
            Reload
          </BootstrapButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ReleaseNotePopup;
